import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ClientItem from './ClientItem';

const ClientSubGallery = ({ type, promotions }) => {
  console.log(JSON.stringify(promotions, null, 2));
  return (
    <Fragment>
      <div className="client-gallery-type"><span>{type}</span></div>
      <div className="client-items">
        {promotions.map((item, index) => (
          <ClientItem item={item} />
        ))}
      </div>
    </Fragment>
  );
};

ClientSubGallery.propTypes = {
  type: PropTypes.string.isRequired,
  promotions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    city: PropTypes.string,
    province: PropTypes.string,
    image: PropTypes.string,
  })).isRequired,
};

export default ClientSubGallery;
